import { render, staticRenderFns } from "./addRejectReason.vue?vue&type=template&id=45bb8109&scoped=true"
import script from "./addRejectReason.vue?vue&type=script&lang=js"
export * from "./addRejectReason.vue?vue&type=script&lang=js"
import style0 from "./addRejectReason.vue?vue&type=style&index=0&id=45bb8109&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb8109",
  null
  
)

export default component.exports